<template>
  <div>
    <div class="row">
      <div class="col-12">
        <p class="text-right">
          <router-link class="btn btn-primary" :to="{ name: 'designations.create' }">
            <font-awesome-icon :icon="['fal', 'plus-circle']" />
            Create
          </router-link>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <v-server-table
          ref="table"
          url="/designations?with=parent;fields"
          :columns="columns"
          :options="options"
        />
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import entity from "../../mixins/entity";
import format from "../../mixins/format";

const columns = ["name", "parent", "fields", "actions"];

export default {
  mixins: [entity, format],

  data() {
    return {
      columns,
      options: {
        templates: {
          parent: (h, o) => (o.parent && o.parent.name ? o.parent.name : null),
          fields: (h, o) => (o.fields ? o.fields.length : 0),
          actions: (h, o) =>
            o.parent_id ? this.entityActionSet(h, o, "designations", this.$refs) : null,
        },
      },
    };
  },
};
</script>
